/* Filthy Clean — wholesale application conversion (added 2026-10-14).
   Loaded only on the wholesale page: the fc_styles section in
   header-group.json adds it inside {% if template.suffix == 'fc-wholesale' %}.

   Why it exists: the application form is a Shopify Forms app block, which
   renders inside an open shadow root on <shopify-forms-embed>. Submit events
   don't cross a shadow boundary, so Shopify's form_submitted pixel event never
   fires for it, and there's no thank-you page to track. So we watch the form
   ourselves and report the Google Ads conversion "Submit wholesale form"
   (count: one) plus a GA4 generate_lead event, through the gtag the Google &
   YouTube app already loads on every page.

   It reports only a SUCCESSFUL application. Forms stamps its current step on
   div#app-embed inside the shadow root as data-current-step: "tease", "form",
   "success" or "error". We report when we see it change to "success" after
   seeing the form, so a failed submit (the "error" step) or a page that loads
   already on success never counts. The email typed into the form is sent as
   user_data for enhanced conversions; gtag hashes it before sending.

   Forms is third-party DOM. If its markup changes, conversions simply stop
   being reported (check Google Ads > Goals for "Submit wholesale form"); the
   form itself is unaffected. */
(function () {
  'use strict';

  var SEND_TO = 'AW-17699184816/YbVUCNCehpwdELDB0PdB'; // Google Ads: Submit wholesale form
  var GA4 = 'G-XLRDBZL86R';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var seenForm = false;
  var sent = false;
  var email = '';

  /* Look gtag up at send time: the Google & YouTube app may load after us.
     Without it, queue on dataLayer so a late gtag.js still picks it up. */
  function gtag() {
    if (typeof window.gtag === 'function') return window.gtag.apply(window, arguments);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  function report() {
    sent = true;
    if (EMAIL.test(email)) gtag('set', 'user_data', { email: email });
    gtag('event', 'conversion', { send_to: SEND_TO });
    gtag('event', 'generate_lead', { send_to: GA4, form_name: 'wholesale_application' });
  }

  function check(root) {
    if (sent) return;
    var app = root.getElementById('app-embed');
    var step = app && app.getAttribute('data-current-step');
    if (step === 'form' || step === 'tease') seenForm = true;
    else if (step === 'success' && seenForm) report();
  }

  function watch(root) {
    /* Keep the latest email as it's typed; the field is gone by the success step. */
    root.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (t && t.getAttribute && t.getAttribute('data-testid') === 'field-email') email = String(t.value || '').trim().toLowerCase();
      },
      true
    );
    check(root);
    new MutationObserver(function () {
      check(root);
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step'] });
  }

  function find() {
    var embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return false;
    watch(embed.shadowRoot);
    return true;
  }

  if (find()) return;

  /* The Forms loader adds the embed and its shadow root after load. The timeout
     stops us leaving an observer running on a page whose form never arrives. */
  var observer = new MutationObserver(function () {
    if (find()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
  }, 20000);
})();
